<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="part01"><a id="page_3"></a>PART I</h2>
<h2 class="h2a">THOSE EARLY YEARS<a id="page_4"></a></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?66a57ef5